import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { UserService } from '@app/core/user.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigRoleGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const tableName = route.paramMap.get('name');
    if (!tableName) return true;

    const roleId = await this.resolveRoleId();
    if (roleId === 1) return true;

    if (roleId === 2 && (tableName === 'project_user' || tableName === 'project_cliente')) {
      this.router.navigateByUrl('/shell/home');
      return false;
    }

    if (roleId === 3) {
      if (tableName === 'project_finca') {
        return true;
      }
      this.router.navigateByUrl('/shell/home');
      return false;
    }

    if (roleId === null) {
      this.router.navigateByUrl('/shell/home');
      return false;
    }

    return true;
  }

  private async resolveRoleId(): Promise<number | null> {
    const existing = this.userService.getRoleId();
    if (existing !== null) return existing;

    try {
      await this.userService.getUserInfo().toPromise();
      return this.userService.getRoleId();
    } catch {
      return null;
    }
  }
}
